import React from "react";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default function MultipleAutocomplete({
  DataList,
  SelectedValues,
  Label,
  Placeholder,
  SetValue,
  CheckLength,
  Disabled,
}) {
  return (
    <Autocomplete
      multiple
      filterSelectedOptions
      noOptionsText="No hay más opciones"
      options={DataList}
      getOptionLabel={(option) => option.text}
      defaultValue={SelectedValues}
      onChange={(e, c) => {
        SetValue(c);
        if (CheckLength) CheckLength(c.length > 0 ?? false);
      }}
      disabled={Disabled ?? false}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={Label}
          placeholder={Placeholder}
        />
      )}
    />
  );
}
